import MetaDecorator from 'components/layout/MetaDecorator';
import Newsletter from 'components/sections/newsletter/newsletter';
import { useGetDownloadPageQuery, useGetHomePageQuery } from 'app/api/gatewayApiSlice';
import LoaderSpinner from 'components/atoms/Loader/LoaderSpinner';
import { DownloadHero } from './hero/downloadHero';
import { OSList } from './osList/osList';
import { AboutRCM } from './aboutRCM/AboutRCM';
import { ReleaseNotes } from './releaseNotes/releaseNotes';
import { SystemRequirements } from './systemRequirements/systemRequirements';

const isValidUrl = (value) => {
  if (!value?.trim()) return false;

  try {
    const url = new URL(value);

    if (!['http:', 'https:'].includes(url.protocol)) {
      return false;
    }

    if (
      url.hostname === 'example.com'
      || url.hostname.endsWith('.example.com')
    ) {
      return false;
    }

    return true;
  } catch {
    return false;
  }
};

export function DownloadRCM() {
  const {
    data: downloadPageData,
    isLoading,
  } = useGetDownloadPageQuery();

  const { data } = useGetHomePageQuery();

  const newsletterData = data?.sections?.newsLetter;

  if (isLoading || !downloadPageData) {
    return <LoaderSpinner />;
  }

  return (
    <div className='downloadRCMContainer'>
      <MetaDecorator
        title='Download Roland Cloud Manager'
        description='Download Roland Cloud Manager to install, update, and manage your Roland Cloud software instruments, effects, and sound content.'
        link='download-rcm'
        addPostfixTitle
      />
      <DownloadHero data={downloadPageData.hero} />
      <OSList data={downloadPageData.osList} />
      {isValidUrl(downloadPageData?.notes?.ctaUrl) && (
      <ReleaseNotes data={downloadPageData.notes} />
      )}
      <SystemRequirements data={downloadPageData.systemRequirements} />
      <AboutRCM data={downloadPageData.aboutRCM} />
      {newsletterData?.enabled && (
        <Newsletter data={newsletterData} />
      )}
    </div>
  );
}
